var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"c-box-button-group"},[(_vm.subjects)?_c('ul',_vm._l((_vm.subjects),function(item,index){return _c('li',{key:index},[_c('c-box-button',{attrs:{"active":item.active,"name":item.name,"text":item.text},on:{"click":_vm.selectSubject}})],1)}),0):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }